import { useState, useEffect } from "react";
import { useGT } from "gt-react";
import { X } from "lucide-react";

const shortcuts = [
  { keys: "⌘ ↩", description: "Execute query" },
  { keys: "⌘ S", description: "Save query" },
  { keys: "⌘ N", description: "New query" },
  { keys: "⌘ P", description: "Quick open" },
  { keys: "⌘ 1", description: "Queries panel" },
  { keys: "⌘ 2", description: "Schema panel" },
  { keys: "⌘ 3", description: "History panel" },
  { keys: "⌘ /", description: "Show shortcuts" },
];

export function KeyboardShortcutsHelp() {
  const t = useGT();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "/") {
        e.preventDefault();
        setOpen((v) => !v);
      }
      if (e.key === "Escape") {
        setOpen(false);
      }
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, []);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm" onClick={() => setOpen(false)}>
      <div className="w-80 rounded-xl bg-surface-raised border border-border p-6 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-sm font-semibold text-zinc-200">{t("Keyboard Shortcuts")}</h2>
          <button onClick={() => setOpen(false)} className="text-zinc-600 hover:text-zinc-400">
            <X size={14} />
          </button>
        </div>
        <div className="space-y-2">
          {shortcuts.map((s) => (
            <div key={s.keys} className="flex items-center justify-between">
              <span className="text-xs text-zinc-400">{s.description}</span>
              <kbd className="rounded bg-surface-overlay px-2 py-0.5 text-[10px] font-mono text-zinc-400">{s.keys}</kbd>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
